<template>
  <v-row>
    <v-col cols="12">
      <v-card class="card-border" elevation="7">
        <v-card-title :title="valinta.otsikko"
                      class="background lighten-10 d-flex justify-space-between align-start">
          <v-row>
            <v-col cols="10">
              <div class="subtitle-2 valinta-title">{{ valinta.otsikko }}</div>
            </v-col>
            <v-col class="text-right" cols="2">
              <v-btn icon @click="goToValinta(valinta)">
                <v-icon
                    small>mdi mdi-pencil
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>


        </v-card-title>
        <v-divider class="background lighten-5"/>
        <v-card-text>
          {{ valinta.kuvaus }}
        </v-card-text>
        <v-card-text>
          <v-row>
            <v-col class="px-1 d-flex flex-wrap justify-space-around align-center flex-gap-1" cols="6">
              <div class="d-flex flex-column align-center">
                <template v-if="valinta.mittarinimi">
                  <v-btn :title="$t('valinta.siirry_valintaan')" class="justify-center"
                         icon
                         @click="goToValinta(valinta)"
                  >
                    <v-avatar
                        :color="tavoiteJaTuoteutuma.prosentti === 100 ? 'success' : tavoiteJaTuoteutuma.prosentti > 0 ? 'warning' : 'error'"
                        size="42"/>

                  </v-btn>
                  <!--<span v-if="valinta.pisteet" class="ml-2 text-no-wrap text-caption">{{ valmiusPisteet }} / {{
                      painotus
                    }}</span>-->
                  <div class="mt-2 text-no-wrap text-caption">
                    <span v-if="tavoiteJaTuoteutuma && tavoiteJaTuoteutuma.prosentti">{{
                        $formatPisteet(tavoiteJaTuoteutuma.prosentti)
                      }} % </span>
                    <span
                        v-if="tavoiteJaTuoteutuma && (tavoiteJaTuoteutuma.toteutuma > 0 || tavoiteJaTuoteutuma.tavoite > 0)">({{
                        tavoiteJaTuoteutuma.toteutuma
                      }}./{{ tavoiteJaTuoteutuma.tavoite }}.)</span>
                    <span
                        v-if="!tavoiteJaTuoteutuma || (!tavoiteJaTuoteutuma.prosentti && !tavoiteJaTuoteutuma.toteutuma)">
                      &nbsp;
                    </span>
                  </div>
                </template>
              </div>
            </v-col>
            <v-col class="px-1 d-flex flex-wrap justify-space-around align-center flex-gap-1" cols="6">
              <div class="d-flex flex-column align-center">
                <v-btn :title="$t('tehtava.siirry_tehtaviin')" icon @click="goToTehtavatView(valinta)">
                  <v-avatar :color="$getValmiusprosenttiColor(valmiusProsentti)"
                            size="42"/>
                </v-btn>
                <div class="mt-2 text-no-wrap text-caption d-inline">
                <span v-if="valmiusProsentti">{{
                    $formatPisteet(valmiusProsentti)
                  }} %</span>
                  <span v-else>
                    &nbsp;
                  </span>
                </div>

              </div>

            </v-col>

          </v-row>


        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "ValintaBox",
  props: {
    valinta: Object,
    vuosi: Number
  },
  data() {
    return {
      nytVuosi: dayjs().year(),
      nytQ: dayjs().quarter(),
    }
  },
  computed: {
    valmiusProsentti() {
      return this.$round(this.valinta.pisteet?.valmiusPisteet / this.valinta.pisteet?.painotus * 100);
    },
    painotus() {
      return this.valinta.pisteet?.painotus
    },
    valmiusPisteet() {
      return this.valinta.pisteet?.valmiusPisteet
    },
    tavoiteJaTuoteutuma() {
      let q = 4
      if (this.nytVuosi === this.valinta.vuosi) {
        q = this.nytQ;
      }
      let tavoite = 0;
      let toteutuma = 0;
      for (let i = 1; i < q; i++) {

        tavoite += this.valinta[`tavoiteQ` + i] || 0;
        toteutuma += this.valinta[`toteutumaQ` + i] || 0;
      }
      let prosentti = this.$round(toteutuma / tavoite * 100)
      if (tavoite == 0) {
        prosentti = 0;
      }

      return {toteutuma, tavoite, prosentti}

    }
  },
  methods: {
    goToTehtavatView(valinta) {
      this.$router.push({
        name: 'tehtavat_vuosi_vastuualue_valinta',
        params: {vuosi: this.vuosi, vastuualueId: valinta.vastuualueId, valintaId: valinta.id,}
      })
    },
    goToValinta(valinta) {
      this.$router.push({
        name: 'asetukset_valinta_muokkaus',
        params: {id: valinta.id,}
      })
    }
  }
}
</script>

<style scoped>

.cursor-pointer {
  cursor: pointer;
}

.flex-gap-1 {
  gap: 6px;
}

.card-border {
  border: 1px solid #565656;
}

.valinta-title {
  -webkit-line-clamp: 2;
  height: 3em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>